import React, { useState, useEffect, useRef } from 'react';
import DesktopUserNav from '../App-Components/DesktopUserNav'
import { IoIosArrowDown } from "react-icons/io";
import { MdNotificationsNone } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import logo from "../../stock/nexus/logo.png"
import { CgMenuLeft } from "react-icons/cg";
import UserNav from '../App-Components/MobileUserNav';
import { CiCircleInfo } from "react-icons/ci";
import traderImage from "../../stock/hands.jpg"
import { IoIosAdd } from "react-icons/io";

import purse from '../../stock/purse.png'
import bitcoin from "../../stock/bitcoin-btc-logo.png"
import Eth from "../../stock/ethereum-eth-logo.png"
import USDT from "../../stock/tether-usdt-logo.png"
import sol from "../../stock/solana-sol-logo.png"

import { RiExchangeDollarLine } from "react-icons/ri";
import { BiTransfer } from "react-icons/bi";
import { RiSendPlaneLine } from "react-icons/ri";
import { MdFormatListBulletedAdd } from "react-icons/md";

import { auth, txtdb } from '../../firebase-config';
import { doc, collection, getDoc, updateDoc, setDoc, deleteDoc } from "firebase/firestore";
import { getDocs, query, orderBy } from "firebase/firestore";

import {
  onAuthStateChanged,
} from "firebase/auth";

import tradersData from './tradersData';
import CopyTradeModal from './CopyTradeModal';


function Market() {

  const [user, setUser] = useState({});

  const [selectedTrader, setSelectedTrader] = useState(null);


    // State to track if the sidebar is visible
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to handle the click event
    const handleNavClick = () => {
      setIsSidebarVisible(!isSidebarVisible); // Toggle sidebar visibility
    };

    //

    const [menuVisible, setMenuVisible] = useState(false);
    const menuRef = useRef(null);

      // Toggle menu visibility when button is clicked
  const handleToggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  // Close the menu when clicking outside
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  

  useEffect(() => {
    document.title = 'Market'

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
    });
  
    // Cleanup function to unsubscribe from the listener when component unmounts
    return () => unsubscribe();
  }, [auth]);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        // console.log("User is logged in:", currentUser);
        setUser(currentUser);
         
      } else {
        // console.log("No user is logged in.");
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup subscription on component unmount
  }, []);

  useEffect(() =>{
    document.title= "My Nexus profile"

  })



  



      //transactions//
      const [transactions, setTransactions] = useState([]);
    
      const fetchTransactions = async () => {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.log("User not logged in.");
          return;
        }
  
        const userId = currentUser.uid;
        const transactionsRef = collection(txtdb, "users", userId, "transactions");
  
        try {
          // Query the transactions, ordered by date (descending)
          const q = query(transactionsRef, orderBy("date", "desc"));
          const querySnapshot = await getDocs(q);
  
          // Map the query results into an array
          const transactionsList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
  
          setTransactions(transactionsList); // Store transactions in state
        } catch (error) {
          console.error("Error fetching transactions: ", error);
        }
      };
  
  
      useEffect(() => {
        fetchTransactions();
      }); 


      //list of investments
      
    
        
     
      
      useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
          setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
        });
      
        // Cleanup function to unsubscribe from the listener when component unmounts
        return () => unsubscribe();
      }, [auth]);
      
      
      
    
      
    
      
    
      const scrollRef = useRef(null);

      const scrollLeft = () => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({ left: -400, behavior: 'smooth' });
        }
      };
    
      const scrollRight = () => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({ left: 400, behavior: 'smooth' });
        }
      };
    
    

  return (
    <div className='layout'>
      <DesktopUserNav />

      <div className="dashboard-container content">

      <div className="container" >

      <div className="navigation-container">

      <NavLink to='/dashboard' className="mobile">
                <img src={logo} alt="keystonecapitals" />
                <p className='name'>Market</p>
      </NavLink>


       <p className='desktop'>Market</p>

       <div className="actions desktop" >

        <div className="quick" onClick={handleToggleMenu} >
        Quick Actions 
        <IoIosArrowDown />

        {menuVisible && (
                         <div className="quick-actions" ref={menuRef}>

                         <NavLink to="/withdrawals" className="settings top">
                             <RiSendPlaneLine className='icon' /> Send Money
                         </NavLink>
     
                         <NavLink to="/trades" className="settings">
                             <MdFormatListBulletedAdd  className='icon' /> New Trade
                         </NavLink>
     
                         <NavLink to="/deposits" state={{ currentPage: "convert" }} className="settings">
                             <RiExchangeDollarLine  className='icon'/> Convert Funds
                         </NavLink>
     
                         <NavLink to="/deposits" className="logout">
                             <BiTransfer  className='icon' /> Fund Wallet
                         </NavLink>
     
                         </div>
                )}
        </div>

       <div className="notif">
       <MdNotificationsNone className='icon' />
       </div>
       </div>

       <div className="actions mobile">

       <div className="notif">
       <MdNotificationsNone className='icon' />
       </div>

       <div className="nav"  onClick={handleNavClick}>
       <CgMenuLeft className='icon' />
       </div>

       </div>

      </div>

      {isSidebarVisible && (
        <UserNav onClose={handleNavClick} />
      )}

      </div>

      
        <div className="market">

            <header>
            <h2>Copy Trade the best traders in the world <CiCircleInfo className='icon'/></h2>
            <p>Follow expert traders automatically and watch your portfolio grow</p>
            </header>

            <div className="market-container">
                <div className="head">Top Traders This Month</div>

                <div className="traders">
                {tradersData.map((trader, index) => (
                    <div key={trader.id} className="trader">
                    <div className="trader-card">
                        <div className="rank-pnl">
                        <h3 className="rank">#{index + 1}</h3>
                        <div className="pnl">{trader.pnlStatus}</div>
                        </div>

                        <img
                        src={trader.image}
                        alt={trader.name}
                        className="trader-bg"
                        />

                        <div className="trader-content">
                        <h2 className="trader-name">{trader.name}</h2>

                        <div className="trader-info">
                            <div className="details">
                            <div className="profit">
                                +${trader.profit.toLocaleString()}{" "}
                                <span>in {trader.period}</span>
                            </div>
                            <div className="total-copies">
                                {trader.copies.toLocaleString()}+{" "}
                                <span>
                                Copy Trades | {trader.winRate}% Win
                                </span>
                            </div>
                            </div>

                          <button className="time" onClick={() => setSelectedTrader(trader)}>
                <p>Copy</p> <IoIosAdd className="copytradeicon" />
              </button>
                        </div>
                        </div>
                    </div>
                    </div>
                ))}
                </div>

                  {selectedTrader && (
        <CopyTradeModal trader={selectedTrader} onClose={() => setSelectedTrader(null)} />
      )}

            </div>

        </div>


      </div>

     



    </div>
  )
}

export default Market